import jQuery from "jquery";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import AnimatedPopup from "mapbox-gl-animated-popup";

(function ($) {
    var current_width = $(window).width(),
        zoom = 1.55,
        iniCenter = [15, 30],
        map_container = "map-ends",
        json_url = "/assets/json/ends_map.json",
        map_container_class = "map-excise-tax-burden",
        mainColumn = "exciseTaxBurden",
        lightest_color = "#D8E8F5",
        light_color = "#B5D2EA",
        medium_color = "#91BBE0",
        lessdark_color = "#2A6CA9",
        dark_color = "#1D466B",
        no_data_color = "#AAAAAA";

    window.initMap = function initMap(data) {
        let initialTab = window.location.hash;
        if (initialTab) {
            let tab = $(`a[href='${initialTab}']`);

            tab.parent().addClass("active");
            $(".taxtaion-price-map-tabs li")
                .not(tab.parent())
                .removeClass("active");

            $(".canHide").hide();
            $(initialTab).show().scroll();
            $(window).scroll(0);

            if (initialTab == "#all-data") {
                allDataHtml(data);
                $(window).scrollTop($("#all-data").offset().top);
            }

            $(".canHide:visible")
        }
        map_container = "map-ends";

        if (current_width < 768) {
            zoom = 0;
            iniCenter = [-14.396, 23];
        }

        $(".reset_map").click(function (e) {
            e.preventDefault();
            $(this).hide();
        });

        $(".taxtaion-price-map-tabs a").on("click", function (e) {
            let map = $(e.currentTarget).attr("href");

            $(".taxtaion-price-map-tabs li").toggleClass("active");
            $(".canHide").hide();
            $(map).show();

            if (map == "#all-data") {
                allDataHtml(data);
            }
        });

        $(".map-legend-ends").html(getMapLegend());

        mapboxgl.accessToken =
            "pk.eyJ1IjoidG9iYWNjb2ZyZWVraWRzIiwiYSI6IlQ3bEdmNW8ifQ.aFJ5TdySQqX7x4ecxAp3Ug";

        const map = new mapboxgl.Map({
            container: map_container,
            // style: "mapbox://styles/tobaccofreekids/cli11vgvq04k601qnejr38ff2",
            style: "mapbox://styles/mapbox/streets-v12",
            center: iniCenter,
            minZoom: zoom,
            projection: "mercator",
            // pitch: 60, // pitch in degrees
            // bearing: -60,
        });

        map.scrollZoom.disable();
        map.addControl(new mapboxgl.NavigationControl());
        map.addControl(new mapboxgl.FullscreenControl());
        map.on("load", function () {
            // Add a new source from our GeoJSON data and set the
            // 'cluster' option to true. GL-JS will add the point_count property to your source data.
            map.addSource("countries", {
                type: "vector",
                // url: "mapbox://tobaccofreekids.9ed97vtt"
                // url: "mapbox://tobaccofreekids.52mzgrhr",
                // url: 'mapbox://mapbox.82pkq93d'
                url: "mapbox://mapbox.country-boundaries-v1",
                // url: "mapbox://tobaccofreekids.64yqhc9r"
            });
            // Add a black outline around the polygon.
            // console.log(data);
            if (!map.getLayer("fill-countries-with-laws")) {
                map.addLayer(
                    {
                        id: "fill-countries-with-laws",
                        type: "fill",
                        source: "countries",
                        filter: data["filterExpression"],
                        // "source-layer": "countries-9eh80z",
                        // "source-layer": "countries",
                        // "source-layer": "world-77bd1d",
                        layout: {},
                        paint: {
                            "fill-color": data["colorExpression"],
                            "fill-opacity": 1,
                        },
                        "source-layer": "country_boundaries",
                        // "source-layer": "TM_WORLD_BORDERS-0-dh2ajy"
                    },
                    "admin-0-boundary"
                );

                map.addLayer({
                    id: "countries-boundaries",
                    type: "line",
                    source: "countries",
                    filter: data["filterExpression"],
                    // "source-layer": "countries-9eh80z",
                    // "source-layer": "countries",
                    // "source-layer": "world-77bd1d",
                    layout: {
                        "line-cap": "square",
                    },
                    paint: {
                        "line-color": "#000",
                        "line-width": 1.4,
                        "line-blur": 4,
                    },
                    "source-layer": "country_boundaries",
                    // "source-layer": "TM_WORLD_BORDERS-0-dh2ajy"
                });

                printGlobes(data["features"], map);
            }

            map.on("click", "fill-countries-with-laws", function (e) {
                // var features = map.queryRenderedFeatures(e.point);
                let bbox = [
                    [e.point.x, e.point.y],
                    [e.point.x, e.point.y],
                ];

                let f = map.queryRenderedFeatures(bbox, {
                    layers: ["fill-countries-with-laws"],
                });
                if (f.length) {
                    // console.log(f);
                    showCountryClusterInfo(e, map, f, data); //topmost feature
                }
            });

            map.on("mouseover", "fill-countries-with-laws", function () {
                map.getCanvas().style.cursor = "pointer";
            });

            map.on("mouseleave", "fill-countries-with-laws", function () {
                map.getCanvas().style.cursor = "";
            });
        });
    };

    function printGlobes(features, map) {
        $.each(features, function (key, country) {
            // console.log(country);
            var mainValue =
                country.properties.exciseTaxBurden == ""
                    ? "N/A"
                    : country.properties.exciseTaxBurden;
            var popupGlobe = new AnimatedPopup({
                closeOnClick: false,
                closeButton: false,
                className:
                    "ends-preview-popup " +
                    country.properties.colorClass +
                    " " +
                    country.countryName,
                openingAnimation: {
                    duration: 2000,
                    easing: "easeOutElastic",
                    transform: "scale",
                },
                closingAnimation: {
                    duration: 300,
                    easing: "easeInBack",
                    transform: "scale",
                },
            })
                .setLngLat(country.properties.coordinates)
                .setHTML("<span>" + mainValue + "</span>")
                .addTo(map);

            popupGlobe.getElement().addEventListener("click", () => {
                showCountryClusterInfo(null, map, null, null, country);
            });

            $(".map-legend-ends #showGlobes").on("click", function (e) {
                if (!popupGlobe) return;
                else if (popupGlobe.isOpen()) popupGlobe.remove();
                else popupGlobe.addTo(map);
                popupGlobe.getElement().addEventListener("click", () => {
                    showCountryClusterInfo(null, map, null, null, country);
                });
                // console.log('hereee');
                // popupGlobes.addTo(map);
            });
        });

        $(".map-legend-ends #mapProjection").on("click", function (e) {
            if ($(this).is(":checked")) {
                // console.log('chekced');
                map.setProjection({
                    name: "globe",
                });
                map.flyTo({
                    center: [-40, 10],
                    duration: 2000,
                    zoom: 1.85,
                });
            } else {
                map.setProjection({
                    name: "mercator",
                });

                map.flyTo({
                    center: iniCenter,
                    pitch: 0,
                    duration: 1000,
                    zoom: zoom,
                });

                $(".ends-preview-popup").css("opacity", 1);
            }
        });
    }

    function showCountryClusterInfo(e, map, features, data, feature = null) {
        // var features = map.queryRenderedFeatures(e.point);
        var countryDescription = "";
        var popUpCoordinates = [0, 0];
        var countryName = "";

        let popupMaxWidth = "240px !important";
        if (screen.width <= 768) {
            popupMaxWidth = "100% !important";
        }

        if (features != null) {
            countryName = features[0].properties.name_en;
            feature = data["features"][countryName];
        } else {
            countryName = feature.countryName;
        }

        if (feature !== undefined) {
            if (screen.width > 768) {
                popUpCoordinates = feature.properties.coordinates.slice();
                if (e != null) {
                    while (Math.abs(e.lngLat.lng - popUpCoordinates[0]) > 180) {
                        popUpCoordinates[0] +=
                            e.lngLat.lng > popUpCoordinates[0] ? 360 : -360;
                    }
                }
            }

            new mapboxgl.Popup()
                .setLngLat(popUpCoordinates)
                .setHTML(
                    "<div class='countryDetails'><h4>" +
                        countryName +
                        "<strong class='year'>" +
                        feature.properties.year +
                        "</strong></h4><div class='countryDescription'>" +
                        popUpEndsContent(feature) +
                        "</div></div>"
                )

                .setMaxWidth(popupMaxWidth)
                .addTo(map);
        } else {
            map.flyTo({
                zoom: map.getZoom() + 1,
                center: e.lngLat,
            });
        }
    }

    function getMapLegend() {
        return `
                <h4>Country excise tax burden <br> on ENDS/ENNDS</h4>
                <div>
                        <span style="background-color: ${no_data_color}"></span>No data
                </div>
                <div>
                        <span style="background-color: ${lightest_color}"></span>Under 10%
                </div>
                <div>
                        <span style="background-color: ${light_color}"></span>10% to 25%
                </div>
                <div>
                        <span style="background-color: ${medium_color}"></span>25% to 40%
                </div>
                <div>
                        <span style="background-color: ${lessdark_color}"></span>40% to 60%
                </div>
                <div>
                        <span style="background-color: ${dark_color}"></span>60% +
                </div>
                
                <div class="row">
                    <div class="form-check form-switch col-md-6">
                        <input class="form-check-input" type="checkbox" role="switch" id="showGlobes" checked>
                        <label class="form-check-label" for="showGlobes">Datapoint</label>
                    </div>


                    <div class="form-check form-switch col-md-6">
                        <input class="form-check-input" type="checkbox" role="switch" id="mapProjection">
                        <label class="form-check-label" for="mapProjection">Globe</label>
                    </div>
                </div>
            `;
    }

    function popUpEndsContent(feature, table_style = "ends-map") {
        var color = feature.properties.color;
        var mapPopUp = `
        <table class="table table-striped taxation-price">
            <thead>
                <tr>
                    <th class="text-center"></th>
                    <th class="text-center"><strong>Excise Type</strong></th>
                    <th class="text-center"><strong>Excise Tax Burden</strong></th>
                    <th class="text-center"><strong>Total Tax Burden</strong></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><strong>ENDS</strong></td>
                    <td class="text-right">
                        <div>${feature.properties.typeOfExciseSystemApplied}</div>
                    </td>
                    <td class="text-right tax-gap" style="background-color:${color}">
                        <div class="text-white">${feature.properties.exciseTaxBurden}</div>
                    </td>
                    <td class="text-center"><div>${feature.properties.totalTaxBurden}</div></td>
                </tr>
            </tbody>
        </table>
        `;

        let comments = truncateText(feature.properties.comments, 320);
        let taxRate = truncateText(feature.properties.taxRateAndUnit, 40);
        var allDataTable = `
        <table class="table table-striped taxation-price ends-map-card">
            <thead>
                <tr>
                    <th class="text-center"></th>
                    <th class="text-center"><strong>Excise <br> Type</strong></th>
                    <th class="text-center"><strong>Excise <br> Tax Burden</strong></th>
                    <th class="text-center"><strong>Total <br> Tax Burden</strong></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Electronic Nicotine Delivery Systems</td>
                    <td>
                        <div>${feature.properties.typeOfExciseSystemApplied}</div>
                    </td>
                    <td>
                        <div class="text-center">${feature.properties.totalTaxBurden}</div>
                    </td>
                    <td>
                        <div class="text-center">${feature.properties.exciseTaxBurden}</div>
                    </td>
                </tr>
                <tr>
                    <td>Explicit excise tax on vaping devices?</td>
                    <td colspan="3">
                        <div>${feature.properties.explicitExciseTaxOnVapingDevices}</div>
                    </td>

                </tr>
                <tr>
                    <td>Excise tax applied to all e-liquids <br> <small>(vs. only nicotine-containing or nicotine-free e-liquids)</small></td>
                    <td colspan="3">
                        <div>${feature.properties.exciseTaxAppliedToAllELiquids}</div>
                    </td>
                </tr>
                <tr>
                    <td>Tax rate and unit</td>
                    <td colspan="3">
                    <div class="tax-rate-comments">${taxRate}</div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="row comments-block ps-2">
            <h4>Comments</h4>
            <div class="col mt-2">
                <p>${comments}</p>
            </div>
        </div>

        `;

        return table_style == "all-data" ? allDataTable : mapPopUp;
    }

    function allDataHtml(data) {
        var countries = data["features"];
        let csvUrl = "ends_data.csv";
        var output = `
            <div class="allData">
                <div class="row">
                    <div class="col-12 text-end mb-3 row-controls">
                        <a href="/exports/csv/${csvUrl}" class="me-4 link-light">
                            <i class="fa-solid fa-file-csv"></i> Download CSV
                        </a>
                        <a href="javascript:window.print();" class="link-light">
                            <i class="fa-solid fa-print"></i>Print
                        </a>
                    </div>`;
        $.each(countries, function (key, country) {
            output += `
            <div class="col-lg-6 p-3">
                <div class="card p-3" style="height:100%">
                    <h4>
                        ${country.properties.countryName}
                        <strong class="year float-end">
                            ${country.properties.year}
                        </strong>
                    </h4>
                    ${popUpEndsContent(country, "all-data")}
                </div>
            </div>
            `;
        });
        output += "</div></div>";

        $("#all-data").html(output);
        $(window).scrollTop($("#all-data").offset().top);
    }

    //END OF INTERACTIVE LITIGATION MAP
    $(document).keyup(function (e) {
        if (e.keyCode === 27) $(".mapboxgl-popup-close-button").click();
    });
})(jQuery);

function truncateText(text, length) {
    if (text.length > length) {
        let txt =
            text.slice(0, length) +
            `<span>...</span><span class="d-none">` +
            text.slice(length) +
            `</span><br> <a href="#readMore" data-read-more=""><span>Read More <i class="fas fa-angle-down"></i></span> <span class="d-none">Read Less <i class="fas fa-angle-up"></i></span></a>`;
        text = txt;
    }
    return text.replace(/\<(?:\/)?p\>/g,"");
}
